import React from 'react'

import alertIcon from '../../../../../assets/icons/alert-icon.svg'

import {
  MessageContainer,
  Message
} from './styles'

const MessageInfo = ({ children, hasBackground, color }) => {
  return (
    <MessageContainer hasBackground={hasBackground} color={color}>
      <img src={alertIcon} alt="alert icon" />
      <Message>{children}</Message>
    </MessageContainer>
  )
}

export default MessageInfo
